import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { AddressItemWithSkeleton } from '../../components/Skeletons/ItemsWithSkeleton';
import AppConfig from '../../config';
import RequestService from '../../services/RequestService';
import TypesService from '../../services/TypesService';
import './Addresses.scss';

const BlockchainsById = TypesService.BlockchainsById;

const { routes } = AppConfig;

const Addresses = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const currencyId = searchParams.get('currencyId');

	const [addresses, setAddresses] = useState();
	const [loading, setLoading] = useState();
	const [currency, setCurrency] = useState();

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const currencySymbol = currency?.Symbol;
	const blockchainId = currency?.BlockchainId;
	const symbolParts = currencySymbol?.split('-') ?? [];
	const icon = symbolParts[0] ?? '';
	const title = symbolParts[0] ?? '';
	const description = symbolParts[1] ?? '';

	const name = BlockchainsById[blockchainId]?.Name ?? '';
	const iconLabel = currencySymbol !== BlockchainsById[blockchainId]?.Icon ? BlockchainsById[blockchainId]?.Icon : null;

	useEffect(() => {
		const currency = availableCurrencies.find(({ Id }) => Id === Number(currencyId));
		setCurrency(currency);
		const fetchAddresses = async () => {
			if (!currencyId) return;
			setLoading(true);
			const res = await RequestService.GetAddressesByCurrency(currencyId).finally(() => setLoading(false));
			setAddresses(res?.Addresses || []);
		};

		fetchAddresses();
	}, []);

	const openAddress = address => {
		navigate({
			pathname: routes.address,
			search: createSearchParams({ currencyId }).toString(),
			hash: address.AddressId.toString(),
		});
	};

	const subheader = [title, name].filter(Boolean).join(' ') + (description ? `(${description})` : '');

	return (
		<div className='Addresses'>
			<PageHeader icon={icon} header={'All addresses'} iconLabel={iconLabel} subheader={<>{subheader}</>} />

			<div className='Address__body'>
				<div className='Address__body__list'>
					<AddressItemWithSkeleton items={addresses} loading={loading} onClick={openAddress} />
				</div>
			</div>
		</div>
	);
};

export default Addresses;
